import { render, staticRenderFns } from "./PaginatedDataTable.vue?vue&type=template&id=d977aeb2&scoped=true"
import script from "./PaginatedDataTable.vue?vue&type=script&lang=js"
export * from "./PaginatedDataTable.vue?vue&type=script&lang=js"
import style0 from "./PaginatedDataTable.vue?vue&type=style&index=0&id=d977aeb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d977aeb2",
  null
  
)

export default component.exports